import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { CreateProcedure } from 'app/dtos/procedure/create-procedure';

@Injectable({
  providedIn: 'root'
})
export class ProcedureService {

  constructor(private httpClientService: HttpClientService) { }
  async getAllProcedures(page, size) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Procedure,
      queryString: `Page=${page}&Size=${size}`
    });
    return await firstValueFrom(observable);
  }

  async createProcedure(formValue) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Procedure
    }, formValue);
    return await firstValueFrom(observable);
  }
  
  async updateProcedure(formValue) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Procedure
    }, formValue);
    return await firstValueFrom(observable);
  }
  

  async getByIdProcedure(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Procedure,
      action: "GetByIdProcedure"
    }, id);
    return await firstValueFrom(observable);
  }

  async getByKindIdProcedures(kindId,referenceId?:number) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Procedure,
      queryString:`referenceId=${referenceId}`
    }, kindId);
    return await firstValueFrom(observable);
  }



  async createProcedures(createProcedures: CreateProcedure[]) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Procedure,
      action: "CreateProcedures"
    }, createProcedures);
    return await firstValueFrom(observable);
  }

  async deleteProcedureFile(id:number){
    const observable:Observable<any> = this.httpClientService.delete({
      controller:ControllerType.Procedure,
      action:"DeleteProcedureFile"
    },id);
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
